/*
 * @Date: 2019-12-08 17:13:38
 * @LastEditors: miaomiaodeng
 * @LastEditTime: 2020-03-11 16:52:10
 * @FilePath: /rongxin.web/src/views/home/index.js
 */
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
// component
import Navbar from '../../../components/navbar/index.vue';
import ProductService from '../../home/product-service/index.vue';
import contactUs from '../../home/contact-us/index.vue';
export default {
  name: 'home',
  components: {
    swiper,
    swiperSlide,
    Navbar,
    ProductService,
    contactUs
  },
  data() {
    return {
      id: null,
      swiperOption: {
        autoplay: {
          disableOnInteraction: false
        },
        speed: 500,
        slideClass: 'my-slide', // 区分首页管理团队再次引用swiper的类名冲突
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'bullets'
        },
        navigation: {
          nextEl: '.my-button-next', // 区分首页管理团队再次引用swiper的类名冲突
          prevEl: '.my-button-prev'
        }
      },
      fromisActiveClass: 'productService',
      serviceArr: [
        {
          imgUrl: require('../../../assets/images/product/pro1.png')
        },
        {
          imgUrl: require('../../../assets/images/product/pro1.png')
        },
        {
          imgUrl: require('../../../assets/images/product/pro1.png')
        }
      ],
      serviceArr2: [
        {
          imgUrl: require('../../../assets/images/product/c1.png')
        },
        {
          imgUrl: require('../../../assets/images/product/pro5.png')
        },
        {
          imgUrl: require('../../../assets/images/product/c3.png')
        }
      ]
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  created() {
    window.scrollTo(0, 0);
    this.id = this.$route.query.id;
  },
  methods: {
    goHome() {
      this.$router.push({path: 'home'});
    },
    mouseenter() {
      this.$refs.mySwiper.swiper.autoplay.stop();
    },
    mouseleave() {
      this.$refs.mySwiper.swiper.autoplay.start();
    },
    goDetail(activeClass, paths) {
      this.$router.push({path: '/' + paths});
      this.fromisActiveClass = activeClass;
    }
  }
};
